import script from "./index.vue?vue&type=script&setup=true&name=layout&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=layout&lang=js"

import "./index.vue?vue&type=style&index=0&id=2494dad4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2494dad4"]])

export default __exports__